import {
  purchaseOrderTypes,
  getListTypes,
  getByIdTypes,
  deliveryVoucherTypes,
  invoiceFileTypes,
  associatedInvoiceTypes,
  requestPaymentTypes,
  requestAutomatedPaymentTypes,
} from "./types";
import { loginTypes, impersonateTypes } from "../auth/types";

const initialState = {
  errorMessage: null,
  isLoading: false,
  orders: null,
  selectedOrder: null,
  deliveryVouchers: null,
  isLoadingVouchers: false,
  invoiceFiles: null,
  isLoadingInvoiceFiles: false,
  invoicesAssociated: null,
  isLoadingInvoices: false,
  isLoadingAssociating: false,
  loadingOrderAction: {},
  loadingPurchaseOrderInvoicesInfo: {},
  purchaseOrderInvoicesInfo: {},
  modal: {
    active: false,
    errors: [],
    successPayments: [],
  },
};

const purchaseOrderReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case loginTypes.LOGOUT_SUCCESS: {
      return {
        ...initialState,
      };
    }
    case impersonateTypes.ROLLBACK_SUCCESS: {
      return {
        ...initialState,
      };
    }

    case getListTypes.REQUEST: {
      return {
        ...state,
        errorMessage: null,
        isLoading: true,
        loadingOrderAction: {},
        loadingPurchaseOrderInvoicesInfo: {},
        purchaseOrderInvoicesInfo: {},
      };
    }

    case getListTypes.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        orders: payload.purchaseOrders,
      };
    }

    case getListTypes.FAILED: {
      return {
        ...state,
        isLoading: false,
        errorMessage: payload,
      };
    }

    case getByIdTypes.REQUEST: {
      return {
        ...state,
        selectedOrder: null,
        isLoading: true,
      };
    }

    case getByIdTypes.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        selectedOrder: payload,
      };
    }

    case getByIdTypes.FAILED: {
      return {
        ...state,
        isLoading: false,
        errorMessage: payload,
      };
    }

    case purchaseOrderTypes.SET_SELECTED_ORDER: {
      return {
        ...state,
        selectedOrder: payload,
      };
    }

    case deliveryVoucherTypes.GET_REQUEST: {
      return {
        ...state,
        errorMessage: null,
        isLoadingVouchers: true,
      };
    }

    case deliveryVoucherTypes.GET_SUCCESS: {
      return {
        ...state,
        deliveryVouchers: payload,
        isLoadingVouchers: false,
      };
    }

    case deliveryVoucherTypes.GET_FAILED: {
      return {
        ...state,
        errorMessage: payload,
        isLoadingVouchers: false,
      };
    }

    case deliveryVoucherTypes.ADD_REQUEST: {
      return {
        ...state,
        errorMessage: null,
        isLoadingVouchers: true,
      };
    }

    case deliveryVoucherTypes.ADD_SUCCESS: {
      return {
        ...state,
        // deliveryVouchers: payload,
        isLoadingVouchers: false,
      };
    }

    case deliveryVoucherTypes.ADD_FAILED: {
      return {
        ...state,
        errorMessage: payload,
        isLoadingVouchers: false,
      };
    }

    case deliveryVoucherTypes.DELETE_REQUEST: {
      return {
        ...state,
        errorMessage: null,
        isLoadingVouchers: true,
      };
    }

    case deliveryVoucherTypes.DELETE_SUCCESS: {
      return {
        ...state,
        deliveryVouchers: state.deliveryVouchers.filter(
          (voucher) => voucher.id !== payload
        ),
        isLoadingVouchers: false,
      };
    }

    case deliveryVoucherTypes.DELETE_FAILED: {
      return {
        ...state,
        errorMessage: payload,
        isLoadingVouchers: false,
      };
    }

    case invoiceFileTypes.GET_REQUEST: {
      return {
        ...state,
        errorMessage: null,
        isLoadingInvoiceFiles: true,
      };
    }

    case invoiceFileTypes.GET_SUCCESS: {
      return {
        ...state,
        invoiceFiles: payload,
        isLoadingInvoiceFiles: false,
      };
    }

    case invoiceFileTypes.GET_FAILED: {
      return {
        ...state,
        errorMessage: payload,
        isLoadingInvoiceFiles: false,
      };
    }

    case invoiceFileTypes.ADD_REQUEST: {
      return {
        ...state,
        errorMessage: null,
        isLoadingInvoiceFiles: true,
      };
    }

    case invoiceFileTypes.ADD_SUCCESS: {
      return {
        ...state,
        isLoadingInvoiceFiles: false,
      };
    }

    case invoiceFileTypes.ADD_FAILED: {
      return {
        ...state,
        errorMessage: payload,
        isLoadingInvoiceFiles: false,
      };
    }

    case invoiceFileTypes.DELETE_REQUEST: {
      return {
        ...state,
        errorMessage: null,
        isLoadingInvoiceFiles: true,
      };
    }

    case invoiceFileTypes.DELETE_SUCCESS: {
      return {
        ...state,
        invoiceFiles: state.invoiceFiles.filter(
          (invoiceFile) => invoiceFile.id !== payload
        ),
        isLoadingInvoiceFiles: false,
      };
    }

    case invoiceFileTypes.DELETE_FAILED: {
      return {
        ...state,
        errorMessage: payload,
        isLoadingInvoiceFiles: false,
      };
    }

    case associatedInvoiceTypes.GET_REQUEST: {
      return {
        ...state,
        invoicesAssociated: null,
        isLoadingInvoices: true,
      };
    }

    case associatedInvoiceTypes.GET_SUCCESS: {
      return {
        ...state,
        invoicesAssociated: payload,
        isLoadingInvoices: false,
      };
    }

    case associatedInvoiceTypes.GET_FAILED: {
      return {
        ...state,
        errorMessage: payload,
        isLoadingInvoices: false,
      };
    }

    case associatedInvoiceTypes.GET_INFO_REQUEST: {
      const { purchaseOrderId } = payload;
      return {
        ...state,
        loadingPurchaseOrderInvoicesInfo: {
          ...state.loadingPurchaseOrderInvoicesInfo,
          [purchaseOrderId]: true,
        },
      };
    }

    case associatedInvoiceTypes.GET_INFO_SUCCESS: {
      const { purchaseOrderId, invoicesInfo } = payload;

      return {
        ...state,
        purchaseOrderInvoicesInfo: {
          ...state.purchaseOrderInvoicesInfo,
          [purchaseOrderId]: invoicesInfo,
        },
        loadingPurchaseOrderInvoicesInfo: {
          ...state.loadingPurchaseOrderInvoicesInfo,
          [purchaseOrderId]: false,
        },
      };
    }

    case associatedInvoiceTypes.GET_INFO_FAILED: {
      const { purchaseOrderId } = payload;
      return {
        ...state,
        errorMessage: payload,
        loadingPurchaseOrderInvoicesInfo: {
          ...state.loadingPurchaseOrderInvoicesInfo,
          [purchaseOrderId]: false,
        },
      };
    }

    case associatedInvoiceTypes.ADD_REQUEST:
    case associatedInvoiceTypes.ADD_E_REQUEST: {
      return {
        ...state,
        isLoadingAssociating: true,
      };
    }

    case associatedInvoiceTypes.ADD_SUCCESS:
    case associatedInvoiceTypes.ADD_FAILED:
    case associatedInvoiceTypes.ADD_E_SUCCESS:
    case associatedInvoiceTypes.ADD_E_FAILED:
      return {
        ...state,
        isLoadingAssociating: false,
      };

    case associatedInvoiceTypes.DELETE_REQUEST: {
      return {
        ...state,
        errorMessage: null,
        isLoadingInvoices: true,
      };
    }

    case associatedInvoiceTypes.DELETE_SUCCESS: {
      return {
        ...state,
        invoicesAssociated: state.invoicesAssociated.filter(
          (invoice) => invoice.id !== payload
        ),
        isLoadingInvoices: false,
      };
    }

    case associatedInvoiceTypes.DELETE_FAILED: {
      return {
        ...state,
        errorMessage: payload,
        isLoadingInvoices: false,
      };
    }

    case requestPaymentTypes.REQUEST: {
      return {
        ...state,
        errorMessage: null,
        isLoadingInvoices: true,
      };
    }

    case requestPaymentTypes.SUCCESS: {
      return {
        ...state,
        isLoadingInvoices: false,
      };
    }

    case requestPaymentTypes.FAILED: {
      return {
        ...state,
        errorMessage: payload,
        isLoadingInvoices: false,
      };
    }

    case requestPaymentTypes.CHANGE_STATE_REQUEST: {
      return {
        ...state,
        errorMessage: null,
        isLoadingInvoices: true,
      };
    }

    case requestPaymentTypes.CHANGE_STATE_SUCCESS: {
      const { paymentsSuccess } = payload;
      return {
        ...state,
        errorMessage: null,
        isLoadingInvoices: false,
        modal: {
          active: true,
          successPayments: paymentsSuccess,
          errors: [],
        },
      };
    }

    case requestPaymentTypes.CHANGE_STATE_FAILED: {
      return {
        ...state,
        errorMessage: null,
        isLoadingInvoices: false,
      };
    }
    case requestPaymentTypes.CHANGE_STATE_SOME_INOVICES_ARE_FAILED: {
      return {
        ...state,
        errorMessage: null,
        isLoadingInvoices: false,
        modal: {
          active: true,
          errors: payload.errors,
          successPayments: payload.paymentsSuccess,
        },
      };
    }
    case requestPaymentTypes.CLOSE_FEEDBACK_MODAL: {
      return {
        ...state,
        errorMessage: null,
        isLoadingInvoices: false,
        modal: {
          active: false,
          errors: [],
          successPayments: [],
        },
      };
    }
    case purchaseOrderTypes.DELETE_REQUEST:
    case purchaseOrderTypes.RESTORE_REQUEST: {
      const { purchaseOrderId } = payload;
      return {
        ...state,
        loadingOrderAction: {
          ...state.loadingOrderAction,
          [purchaseOrderId]: true,
        },
      };
    }

    case purchaseOrderTypes.DELETE_SUCCESS: {
      const { purchaseOrderId } = payload;
      return {
        ...state,
        orders: state.orders.map((order) => {
          // eslint-disable-next-line no-param-reassign
          if (order.orderId === purchaseOrderId) order.deleted = true;
          return order;
        }),
        loadingOrderAction: {
          ...state.loadingOrderAction,
          [purchaseOrderId]: false,
        },
      };
    }

    case purchaseOrderTypes.RESTORE_SUCCESS: {
      const { purchaseOrderId } = payload;
      return {
        ...state,
        orders: state.orders.map((order) => {
          // eslint-disable-next-line no-param-reassign
          if (order.orderId === purchaseOrderId) order.deleted = false;
          return order;
        }),
        loadingOrderAction: {
          ...state.loadingOrderAction,
          [purchaseOrderId]: false,
        },
      };
    }

    case purchaseOrderTypes.DELETE_FAILED:
    case purchaseOrderTypes.RESTORE_FAILED: {
      const { purchaseOrderId } = payload;
      return {
        ...state,
        loadingOrderAction: {
          ...state.loadingOrderAction,
          [purchaseOrderId]: false,
        },
      };
    }

    case requestAutomatedPaymentTypes.REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case requestAutomatedPaymentTypes.FAILED:
    case requestAutomatedPaymentTypes.SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }

    default:
      return state;
  }
};

export default purchaseOrderReducer;
